import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { useRef } from 'react';
import { DataGrid } from 'devextreme-react';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { parameterService } from '@/projects/syncflow/services/parameter-service';
import { toast } from 'react-toastify';

const ParameterP002Detail = ({ data, parameterCode }: { data: any[]; parameterCode: any }) => {
 
  const save_grid_data = async (e: DataGridTypes.SavingEvent) => {
  e.cancel = true;
 const gridInstance = e.component;

  const updatedData = e.changes
    .filter(change => change.type === "update")
    .map(change => ({
        data:gridInstance.getVisibleRows().find(row => row.key === change.key)?.data,      
      key: {
         parameterCode,
      }
    }));

  if (updatedData.length === 0) {
    toast.info(t('syncflow:no_changes'));
    return;
  }

  try {
    await parameterService.saveParameterDetail(updatedData);
    toast.success(t('syncflow:msg_saved'));
    gridInstance.refresh(); 
  } catch (error) {
    toast.error(t('syncflow:msg_save_error'));
  }
};

  const dataGridRef = useRef<DataGrid>(null);
  return (  
    <DataGridWrapper
            datasource={data}
            props={{ ref: dataGridRef }}
            height={400}
            key={'parameterCode'}
            onSaving={save_grid_data}
            searchPanelVisible={false}
            columnChooser={false}
            editingConfig={{
              mode: 'batch',
              useIcons: false,
              allowAdding: false,
              allowDeleting: false,
              allowUpdating: true,
            }}
            columns={[       
              { dataField: 'code', 
                caption: t('syncflow:options'), 
                allowEditing: false, 
                alignment: 'left',                
                cellRender: code_cell_render,
              },
              {
                dataField: 'is_selected',
                caption: t('syncflow:choose'),
                dataType: 'boolean',
                allowEditing: true,
                alignment: 'center',
                width: 150,
                calculateCellValue: (rowData: any) => !!rowData.is_selected,
                setCellValue: (newData:any, value:any) => {
                  newData.is_selected = value ? 1 : 0;
                },
              }, 
              { dataField: 'parameterCode', allowEditing: false,visible:false },   
            ]}
          />
  );
};
const code_cell_render = (data: any) => (t('syncflow:' + data.row.data.code));

export default ParameterP002Detail;